import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var orderDetailRebateRoute = [{
  path: "order-detail-rebate/:orderNumber",
  name: "orderDetailRebate",
  component: function component() {
    return import( /* webpackChunkName: "login" */"./order-detail-rebate.vue");
  }
}];